module.exports = __webpack_public_path__ + "img/male-child-head.4a2b7173.svg";